import { handleApiCalls } from './axiosInstance';

/**
 * Fetches the aggregated Compliance Watch data for a company dashboard.
 *
 * @param {string} companyId
 * @returns {Promise<object>}
 */
export const fetchComplianceWatchAggregatedData = async companyId => {
  const url = `${process.env.REACT_APP_HOST_API}compliance-watch-snapshots/aggregated-data`;
  const response = await handleApiCalls('get', url, { params: { companyId } });

  return response.data;
};
